import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class RedepositoChequeService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerTodosRedeposito(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: redeposito_chequeInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          redeposito_cheque {
            obtenerTodosRedeposito(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  numero_doc
                  codigo
                  deposito_documento_codigo
                  motivo
                  fecha
                  monto
                  fecha_registro
                  cliente_proveedor_rut
                  empresa_rut
                  sucursal_codigo
                  rut_usuario
                  cliente_proveedor_nombre
                  nombre_usuario
                  pago_codigo
                  codigo_banco
                  nombre_banco
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.redeposito_cheque.obtenerTodosRedeposito
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerSegunFiltro(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: redeposito_chequeInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          redeposito_cheque {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  numero_doc
                  codigo
                  deposito_documento_codigo
                  motivo
                  fecha
                  monto
                  fecha_registro
                  cliente_proveedor_rut
                  empresa_rut
                  sucursal_codigo
                  rut_usuario
                  cliente_proveedor_nombre
                  nombre_usuario
                  pago_codigo
                  codigo_banco
                  nombre_banco
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.redeposito_cheque.obtenerSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: redeposito_chequeInputType) {
          redeposito_cheque {
            obtenerExcel(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                rutaArchivo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.redeposito_cheque.obtenerExcel
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerRedepositoSegunCodigo(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: redeposito_chequeInputType) {
          redeposito_cheque {
            obtenerRedepositoSegunCodigo(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                numero_doc
                codigo
                motivo
                fecha
                monto
                fecha_registro
                cliente_proveedor_rut
                empresa_rut
                sucursal_codigo
                rut_usuario
                cliente_proveedor_nombre
                nombre_usuario
                pago_codigo
                codigo_banco
                nombre_banco
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.redeposito_cheque.obtenerRedepositoSegunCodigo
        callback({ mensajes, respuesta })
      }
    );
  }

  guardarRedeposito(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        mutation ($entidad: redeposito_chequeInputType) {
          redeposito_cheque {
            guardarRedeposito(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                protesto_cheque_codigo
                pago_codigo
                motivo
                fecha
                monto
                fecha_registro
                cliente_proveedor_rut
                empresa_rut
                sucursal_codigo
                rut_usuario
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.redeposito_cheque.guardarRedeposito
        callback({ mensajes, respuesta })
      }
    );
  }

}
